import React from "react";
import { useParams } from "react-router-dom";
import TitleContainer from "../../components/common/Layout/TitleContainer";
import { LaunchpadMain } from "../../components/NewYear/Launchpad";

const LaunchpadPage = () => {
  const { eventId } = useParams();

  return (
    <>
      <TitleContainer
        title="선착순 퀴즈 이벤트"
        description="퀴즈를 맞추고 선착순으로 경품을 받아가세요!"
        style={{ "bkg-grey-ultralight": true }}
      />
      <div className="section-block clearfix pt-0 pb-0 bkg-grey-ultralight">
        <div className="row">
          <div className="column width-10 offset-1 content-inner">
            <LaunchpadMain eventId={eventId} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LaunchpadPage;
